module.exports = __webpack_public_path__ + "media/images/emoticons/copyright-83e7345f6fdac7ddb430628b033c2d7e.gif";